import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addTodaysDeals } from '../../store/todaysDeals';
import { addTopSellingProducts } from '../../store/topSellingProducts';
import Loading from '../../components/Loading';
import PaginationBtn from '../../components/PaginationBtn';
import fetch from '../../utils/fetch';
import Product from '../Products/singleproduct';
import _ from 'lodash';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import PriceRange from '../../components/PriceRange';
import constants from '../../utils/constants.json';
import SortBy from './SortBy';
import { filterByBrandsAndColors, isMobile, setBrandsAndColors, sortProducts } from '../../utils/fn';

import banner_2 from '../../assets/banners/banner_2.png';
import Topsellingcard from '../Products/topsellingcard';
import { Shuffle } from '../../utils/functions';

function TodaysDeals() {
	useDocumentTitle('Todays Deals');

	const dispatch = useDispatch();

	const todaysDeals = useSelector((state) => state.todaysDeals.data);
	const topSelling = useSelector((state) => state.topSellingProducts.data);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const [brands, setBrands] = useState([]);
	const [colors, setColors] = useState([]);

	const [sortBy, setSortBy] = useState('rand');
	const [brandFilters, setBrandFilters] = useState([]);
	const [colorFilters, setColorFilters] = useState([]);

	const [minPriceRange, setMinPriceRange] = useState(constants.MIN_PRICE);
	const [maxPriceRange, setMaxPriceRange] = useState(constants.MAX_PRICE);

	const [topSellingProducts, settopSellingProducts] = useState([]);
	const [productGroups, setProductGroups] = useState([]);
	const [productsToView, setProductsToView] = useState([]);
	const [viewGroupPosition, setViewGroupPosition] = useState(0);

	useEffect(() => {
		if (!todaysDeals) {
			loadData();
		} else {
			setBrandsAndColors(todaysDeals, setBrands, setColors);
			sortedAndFiltered();
		}
	}, [todaysDeals]);

	useEffect(() => {
		setProductsToView(productGroups[viewGroupPosition] || []);
	}, [viewGroupPosition, productGroups]);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, [productsToView]);

	useEffect(() => sortedAndFiltered(), [todaysDeals, sortBy, colorFilters, brandFilters, brands, colors, minPriceRange, maxPriceRange]);

	useEffect(() => { loadtopselling() }, []);

	function loadtopselling() {
		fetch
			.get('getTopSellingProducts')
			.then((res) => {
				settopSellingProducts(Shuffle(res.list))
			})
			.catch((err) => {
			});
	}

	function loadData() {
		if (loading) return;
		setLoading(true);
		setError('');
		fetch
			.get('getTodaysDeals')
			.then((res) => {
				if (res.list.length > 0) {
					dispatch(addTodaysDeals(res.list));
					setLoading(false);
				} else {
					if (topSelling) {
						setLoading(false);
						dispatch(addTodaysDeals(topSelling));
					} else {
						fetch
							.get('getTopSellingProducts')
							.then((res) => {
								dispatch(addTopSellingProducts(res.list));
								dispatch(addTodaysDeals(res.list));
								setLoading(false);
							})
							.catch((err) => {
								setLoading(false);
								setError(err.message);
							});
					}
				}
			})
			.catch((err) => {
				setError(err.message);
				setLoading(false);
			});
	}

	function sortedAndFiltered() {
		let filtered = todaysDeals;
		if (!filtered) return;

		filtered = filtered.filter((item) => parseFloat(item.itemPrice) >= minPriceRange && parseFloat(item.itemPrice) <= maxPriceRange);
		filtered = filterByBrandsAndColors(filtered, brandFilters, colorFilters);
		filtered = sortProducts(filtered, sortBy);

		setViewGroupPosition(0); // we will check on this
		setProductGroups(filtered);
	}

	function brandFilterAction(val, checked) {
		setBrandFilters((brands) => {
			let arr;
			if (checked) {
				arr = [...brands];
				arr.push(val);
			} else {
				arr = brands.filter((brand) => brand != val);
			}
			return arr;
		});
	}

	function colorFilterAction(val, checked) {
		setColorFilters((colors) => {
			let arr;
			if (checked) {
				arr = [...colors];
				arr.push(val);
			} else {
				arr = colors.filter((color) => color != val);
			}
			return arr;
		});
	}

	return (
		<div className="main-body">
			<h2 className="plain-title">Todays Deals</h2>
			{/* {<div className="banner" onClick={() => { }} style={{ backgroundImage: `url(${banner_2})` }}></div>} */}
			<div className="products-category">
				<div className="sub-menu sections">
					<div className="listing">
						<h4>Brand</h4>
						<div className="lists">
							{brands.map((brand, index) => (
								<label className="flex" key={brand.brand + index}>
									<input type="checkbox" onChange={(e) => brandFilterAction(brand.brand, e.target.checked)} />
									<span>{_.upperFirst(brand.brandName)}</span>
								</label>
							))}
							{brands.length === 0 && <label>-</label>}
						</div>
					</div>
					<div className="listing">
						<h4>Colors</h4>
						<div className="lists">
							{colors.map((color, index) => {
								return (
									<label className="flex" key={color.color + index}>
										<input type="checkbox" onChange={(e) => colorFilterAction(color.color, e.target.checked)} />
										<span>{_.upperFirst(color.colorName)}</span>
									</label>
								);
							})}
							{colors.length === 0 && <label>-</label>}
						</div>
					</div>
					<PriceRange
						onRequest={(min, max) => {
							setMinPriceRange(min);
							setMaxPriceRange(max);
						}}
					/>
					<SortBy onSorted={setSortBy} />
					{isMobile() &&
						<div>
							<h4>BEST SELLERS</h4><br />
							<div className='wraptopsellingcards' style={{ height: productsToView.length * 50 }} >
								{topSellingProducts?.map((val, key) => {
									return (
										<Topsellingcard product={val} key={key} />
									)
								})}
							</div>
						</div>
					}
				</div>
				<div className="right-side sections">
					{!error && !loading && productsToView.length === 0 && <p>There are no products to view</p>}
					{error && (
						<div style={{ padding: '20px' }}>
							<h3>Error!!</h3>
							<p>{error}</p>
						</div>
					)}
					{loading && <Loading />}
					{productsToView && (
						<>
							<div className="products-view">
								{productsToView.map((product, index) => (
									<Product data={product} key={index} />
								))}
							</div>
							{productGroups.length > 1 && <PaginationBtn data={{ size: productGroups.length, position: viewGroupPosition, onChange: setViewGroupPosition }} />}
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default React.memo(TodaysDeals);
